import { render, staticRenderFns } from "./workItems.vue?vue&type=template&id=758ad818"
import script from "./workItems.vue?vue&type=script&lang=ts"
export * from "./workItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports